<template>
	<div class="trun-role">
		<div class="page-handle">
			<div class="left">
				<a-button v-auth="'100201'" type="primary" @click="addRoleModel">新建角色</a-button>
			</div>
			<div class="right">
				<a-input-search placeholder="请输入角色名称" style="width: 200px" @search="searchData"/>
			</div>
		</div>
		<div class="page-content page-turn-content">
			<a-table
					:pagination="false"
					:columns="columns"
					:dataSource="data"
					:loading="loading"
					:rowKey="record => record.roleId"
					class="hospital-table"
					size="middle"
			>
				<div slot="recordIndex" slot-scope="text,record,index">
					{{(pageSize*page-pageSize)+index+1}}
				</div>
				<div slot="_userData" slot-scope="text,record,index" style="word-break: break-all;">
					<span v-if="text.length==0">-</span>
					<span class="user-span" v-for="(item,index) in text" :key="index">{{item.nickName}}</span>
				</div>
				<template slot="handle" slot-scope="text,record,index">
					<router-link
							v-if="record.roleId!=1 && record.system"
							v-auth="'100202'"
							to
							@click.native="editRoleModel(record)"
					>查看
					</router-link>
					<router-link
							v-if="record.roleId!=1 && !record.system"
							v-auth="'100202'"
							to
							@click.native="editRoleModel(record)"
					>编辑
					</router-link>
					<span v-if="record.roleId!=1" v-auth="'100204'" style="margin:0 5px;color:#428EF7;">/</span>
					<router-link
							v-if="record.roleId!=1"
							v-auth="'100204'"
							to
							@click.native="ckRoleMemberModel(record)"
					>成员维护
					</router-link>
					<span v-if="!record.system" v-auth="'100203'" style="margin:0 5px;color:#428EF7;">/</span>
					<router-link
							v-if="!record.system"
							v-auth="'100203'"
							to
							@click.native="deleteRole(record)"
					>删除
					</router-link>
				</template>
			</a-table>
		</div>
		<div class="pagination">
			<a-pagination
					@change="pageChange"
					:pageSize.sync="pageSize"
					v-model="page"
					size="small"
					:total="roleMenuData.total"
			/>
		</div>
		<page-model @close="closeModel" :visible="visible||memberIsVisible">
			<role-add v-if="visible" :roleData="selectData" @close="closeModel"></role-add>
			<role-member v-if="memberIsVisible" :roleData="selectData" @close="closeModel"></role-member>
		</page-model>
		<h-confirm
				:visible="confirmVisible"
				@close="closeConfirm"
				@ok="okClick"
				:loadding.sync="confirmLoadding"
				:title="currentConfirmData.title"
				:content="currentConfirmData.content"
				:desc="currentConfirmData.desc"
		></h-confirm>
	</div>
</template>

<script>
  import RoleAdd from "./roleAdd.vue";
  import RoleMember from "./roleMember.vue";

  const columns = [
    {
      title: "序号",
      width: "5%",
      scopedSlots: {customRender: "recordIndex"}
      // customRender: (text, record, index) => `${index + 1}`
    },
    {
      title: "角色名称",
      width: "15%",
      dataIndex: "roleName"
    },
    {
      title: "角色描述",
      dataIndex: "remark",
      width: "30%",
      customRender: (text, record, index) => {
        if (!record.remark) {
          return '-'
        } else {
          return record.remark
        }
      }
    },
    {
      title: "成员列表",
      dataIndex: "_userData",
      width: "35%",
      scopedSlots: {customRender: "_userData"}
    },
    {
      title: "操作",
      scopedSlots: {customRender: "handle"},
      width: "15%"
    }
  ];
  export default {
    data() {
      return {
        columns,
        data: [],
        page: 1,
        pageSize: 10,
        visible: false,
        loading: false,
        roleName: "",
        selectData: {},
        roleMenuData: [],
        memberIsVisible: false,
        confirmLoadding: false,
        confirmVisible: false,
        currentConfirmData: {
          title: "角色删除",
          content: "您确认删除这条数据么？",
          desc: ""
        }
      };
    },
    components: {RoleAdd, RoleMember},
    mounted() {
      this.getRoleData();
    },
    methods: {
      closeConfirm() {
        this.confirmVisible = false;
      },
      deleteRole(item) {
        this.confirmVisible = true;
        this.selectData = item;
      },
      searchData(val) {
        this.roleName = val;
        this.page = 1;
        this.pageSize = 10;
        this.getRoleData();
      },
      okClick() {
        this.$get("role/" + this.selectData.roleId, {}).then(
          res => {
            if (res.data && res.data.code) {
              this.confirmVisible = false;
              this.confirmLoadding = false;
              this.$message.success("删除数据成功");
              this.getRoleData();
            } else {
              this.confirmLoadding = false;
              this.$message.error(res.data.message);
            }
          },
          err => {
            this.confirmLoadding = false;
            this.$message.error("删除数据失败");
          }
        );
      },
      pageChange(page, pagesize) {
        this.page = page;
        this.pageSize = pagesize;
        this.getRoleData();
      },
      getRoleData() {
        this.data = [];
        this.loading = true;
        this.$get("role/getRoleUserList", {
          pageSize: this.pageSize,
          pageNum: this.page,
          roleName: this.roleName
        }).then(res => {
          this.roleMenuData = res.data
          this.data = res.data.rows;
          // this.roleMenuData.forEach(item => {
          //   this.getUserData(item.roleId, data => {
          //     item._userData = data;
          //     this.data.push(item);
          //   });
          // });
          this.data.forEach(item => {
            item._userData = item.userList
          });
          this.loading = false;
        });
      },
      getUserData(id, callback) {
        this.$get("user", {
          pageSize: 10000,
          roleId: id
        }).then(res => {
          if (callback) callback(res.data.rows);
        });
      },
      editRoleModel(item) {
        this.selectData = item;
        this.visible = true;
      },
      addRoleModel(item) {
        this.selectData = null;
        this.visible = true;
      },
      ckRoleMemberModel(item) {
        this.selectData = item;
        this.memberIsVisible = true;
      },
      closeModel() {
        this.visible = false;
        this.memberIsVisible = false;
        this.getRoleData();
      }
    }
  };
</script>

<style lang="scss" scoped>
	.trun-role {
		.user-span {
			margin-right: 10px;
		}
		.pagination {
			padding: 0 30px;
		}
	}
</style>